module.exports = __webpack_public_path__ + "static/media/board_view_campus_img_s.26d050a8.png";